import React from 'react';
import * as PropTypes from 'prop-types';
import Icon from '../../../Icon';
import Button from '../Button';
import './style.scss';

const ZzbReceive = ({ value, onConfirm }) => {
  return (
    <article className="ap-zzb-receive">
      <div className="ap-zzb-receive-icon" />
      <h5>打卡成功</h5>
      <p className="ap-zzb-receive-text">
        恭喜获得
        <span>{value}</span>
        猪猪币
      </p>
      <section className="ap-zzb-receive-image" />
      <p className="ap-zzb-receive-notice">
        <Icon name="info" className="icon-info" />
        <span>您可从自驾圈进入优惠头条</span>
      </p>
      <Button text="知道了" onClick={onConfirm} size="large" />
    </article>
  );
};

ZzbReceive.propTypes = {
  value: PropTypes.number.isRequired,
  onConfirm: PropTypes.func.isRequired
};

export default ZzbReceive;
